export const graphqlBaseUrl = "https://api-bingo.classnotes.co/graphql/creators";
export const graphqlUsersBaseUrl = "https://api-bingo.classnotes.co/graphql/users";
